import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations";
import { BGProps } from "@/libraries/wpl/foundations/src";

import ContentBlocksInline from "../../../../../patterns/wpl/content-blocks-inline/src";

const HeroTryGraphCard = () => {
    const intl = useIntl();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.graphCard.bodyText",
        defaultMessage:
            "Collaborate seamlessly across cross-functional teams, at scale"
    });
    const imgLink =
        "https://wac-cdn.atlassian.com/dam/jcr:6f126124-1d52-4017-9078-40df4c78897e/illustrations-spot-Connections.svg?cdnVersion=1408";
    const imgAltText = intl.formatMessage({
        id: "TryPageTemplate.hero.graphCard.imgAltText",
        defaultMessage: "Connections illustration"
    });

    return {
        headerText: "",
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};

const HeroTryLockCard = () => {
    const intl = useIntl();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.lockCard.bodyText",
        defaultMessage:
            "Built with industry-leading privacy, security, and data control"
    });

    const imgLink =
        "https://wac-cdn.atlassian.com/dam/jcr:c0c94526-036b-44df-9f0d-cd1e9455d1e2/illustrations-spot-Trust%20and%20Security.svg?cdnVersion=1408";
    const imgAltText = intl.formatMessage({
        id: "TryPageTemplate.hero.lockCard.imgAltText",
        defaultMessage: "Trust and security illustration"
    });

    return {
        headerText: "",
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};

const HeroTryPuzzleCard = () => {
    const intl = useIntl();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.puzzleCard.bodyText",
        defaultMessage:
            "Customize your products with 1,000+ apps and integrations"
    });
    const imgLink =
        "https://wac-cdn.atlassian.com/dam/jcr:3dfc6901-1535-48aa-a25a-870ee1d5ff8e/illustrations-spot-Integration%20Puzzle.svg?cdnVersion=1408";
    const imgAltText = intl.formatMessage({
        id: "TryPageTemplate.hero.puzzleCard.imgAltText",
        defaultMessage: "Integration puzzle illustration"
    });

    return {
        headerText: "",
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};

const sectionCssOverride = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "h2": {
        color: wacToken("color.extended.blue900")
    },
    "@media(min-width: 1440px)": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h2: {
            fontSize: "3rem",
            lineHeight: "3.5rem",
            marginBlockEnd: "24px",
            letterSpacing: "0",
            marginBlockStart: "0"
        }
    },
    "@media not all and (min-width: 48rem)": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h2: {
            fontSize: "2rem !important",
            marginBlockStart: "0",
            lineHeight: "1.25",
            marginBlockEnd: "14px"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".img-section img": {
        height: "74px;",
        aspectRatio: "1/1 !important",
        objectFit: "contain !important"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".text-section p": {
        textAlign: "center",
        fontSize: "1.25rem",
        letterSpacing: ".3px",
        lineHeight: "1.4",
        marginBlockEnd: "0",
        color: wacToken("color.neutral.light800")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".styled-background > div:first-child": {
        "padding-bottom": "32px !important",
        "padding-top": "64px !important"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".row-layout": {
        "padding-top": "16px !important",
        "marginBlockStart": "0 !important"
    }
});

const outerContainerCssOverride = css({
    boxShadow: token("elevation.shadow.overlay"),
    position: "relative"
});

const HeroSection = () => {
    const intl = useIntl();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.header",
        defaultMessage: "Try Atlassian apps for free"
    });

    const bodyText = intl.formatMessage({
        id: "TryPageTemplate.hero.bodyText",
        defaultMessage:
            "Our cloud products empower teams of all types, from startup to enterprise."
    });

    const backgroundProps: BGProps = {
        bgColor: wacToken("color.neutral.light100")
    };

    return (
        <section css={sectionCssOverride}>
            <div css={outerContainerCssOverride}>
                <ContentBlocksInline
                    headerText={headerText}
                    bodyText={bodyText}
                    backgroundProperties={backgroundProps}
                    inlineContentBlocks={[
                        HeroTryGraphCard(),
                        HeroTryLockCard(),
                        HeroTryPuzzleCard()
                    ]}
                />
            </div>
        </section>
    );
};

export default HeroSection;
